import { NextImage } from '@components/nextImage/NextImage';
import { AffiliateLinkProps } from './AffiliateLink.types';
import { Arrow, Column, Container, RightText, Text } from './styles';

export const AffiliateLink = ({ image, href, text, title }: AffiliateLinkProps) => {
  return (
    <Container href={href}>
      <Column>
        <NextImage src={image} alt="affiliate" width={24} height={24} />
        <Text bold>{title}</Text>
      </Column>
      <Column alignRight>
        <RightText>
          {text} <Arrow />
        </RightText>
      </Column>
    </Container>
  );
};
